import styled from "styled-components"

import { FeatureCTA as CTA } from "../features/styled"
import { devices } from "../../utils/styleVariables"

const FeatureCTA = styled(CTA)`
  width: 80%;

  form {
    width: 100%;
  }
  button {
    margin-top: 0;
  }
  @media ${devices.tablet} {
    width: 100%;

    form {
      width: 40%;
    }
  }
`

export { FeatureCTA }
